/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DraftArticle } from '../../models/draft-article';

export interface GetDraftArticle$Params {
  id: string;
}

export function getDraftArticle(http: HttpClient, rootUrl: string, params: GetDraftArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<DraftArticle>> {
  const rb = new RequestBuilder(rootUrl, getDraftArticle.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DraftArticle>;
    })
  );
}

getDraftArticle.PATH = '/v0/draft-articles/{id}';
